var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isProcessing)?_c('div',{staticClass:"group"},_vm._l((_vm.items),function(item){return _c('div',{key:item.title,staticClass:"group__menu"},[_c('group-menu',{attrs:{"item":item}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }